import { Link2 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { usageFor } from "@/lib/formUsage";

const KIND_LABEL = { card: "Site Checks", print: "Print", peek: "Dock Manager", email: "Emails", rule: "Database rule" };

/** Small "used in N places" chip for a Field Designer switch. */
export const UsageBadge = ({ scope, itemKey }) => {
  const uses = usageFor(scope, itemKey);
  if (!uses.length) return null;
  const groups = uses.reduce((g, u) => ({ ...g, [u.kind]: [...(g[u.kind] || []), u.text] }), {});
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-0.5 rounded-full bg-sky-50 px-1.5 py-0.5 text-[10px] font-medium text-sky-700 ring-1 ring-sky-200 hover:bg-sky-100 transition-colors"
          title="Other screens that depend on this switch"
          data-testid={`fd-usage-${scope}-${itemKey}`}
        >
          <Link2 className="h-3 w-3" /> {uses.length}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 text-xs" data-testid={`fd-usage-popover-${scope}-${itemKey}`}>
        <div className="mb-1.5 font-semibold text-slate-900">Also used in</div>
        <div className="space-y-2">
          {Object.entries(groups).map(([kind, items]) => (
            <div key={kind}>
              <div className="text-[10px] uppercase tracking-wider text-slate-400">{KIND_LABEL[kind]}</div>
              <ul className="mt-0.5 space-y-0.5 text-slate-700">
                {[...new Set(items)].map((t) => <li key={t}>• {t}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <p className="mt-2 text-[10px] text-slate-400">Hiding or renaming this changes those screens too.</p>
      </PopoverContent>
    </Popover>
  );
};
